export default "__VITE_ASSET__CcnyN7kT__"